export default __webpack_public_path__ + "static/media/close.e8658ac4.svg";